videoroomClient.directive('videoroomClient', [
    'templateCache',
    '$parse',
    'helperService',
    'logService',
    function (templateCache, $parse, helperService, logService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'videoroom_client/templates/' + helperService.getRedesignPathPrefix() + 'videoroomClient.html'
            )
        };
    }
]);
